/* Avenue direct Enrollio forms. Existing funnel URLs remain the no-JS fallback. */
(() => {
  'use strict';
  const routes = new Map([
    ['/info-pack-request', { title: 'Get an Info Pack', formId: 'yrPeH4ng3SUsU5IjFOjT' }],
    ['/trial-booking', {title: 'Book a Trial', formId: 'pp1P9lKvPEWvrYwbtEEs', continueToBookingPage: true}]
  ]);
  const dialog = document.createElement('dialog');
  dialog.id = 'avenue-enrollio-dialog';
  dialog.setAttribute('aria-labelledby', 'avenue-enrollio-title');
  dialog.innerHTML = '<div class="avenue-popup-header"><h2 id="avenue-enrollio-title"></h2><button type="button" class="avenue-popup-close" aria-label="Close form"><span aria-hidden="true">×</span></button></div><p class="avenue-popup-loading" role="status">Loading your form…</p><div class="avenue-popup-content"></div><div class="avenue-popup-footer" hidden><a target="_blank" rel="noopener" class="avenue-popup-fallback">Open form in a new tab</a></div>';
  document.body.append(dialog);
  const content = dialog.querySelector('.avenue-popup-content');
  const loading = dialog.querySelector('.avenue-popup-loading');
  const fallback = dialog.querySelector('.avenue-popup-fallback');
  const footer = dialog.querySelector('.avenue-popup-footer');
  let trigger, previousOverflow, currentUrl, loadTimer;
  const close = () => dialog.close();
  dialog.querySelector('.avenue-popup-close').addEventListener('click', close);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    // Keep the iframe mounted: accidental close/reopen should not discard entered details.
    if (trigger?.isConnected) trigger.focus();
  });
  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor || dialog.contains(anchor) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
    const url = new URL(anchor.href, location.href);
    const route = routes.get(url.pathname.replace(/\/$/, ''));
    if (url.origin !== 'https://join.theavenue.net.au' || !route) return;
    const { title, formId, continueToBookingPage = false } = route;
    const formUrl = new URL('https://link.theavenue.net.au/widget/form/' + formId);
    formUrl.search = url.search;
    event.preventDefault();
    trigger = anchor;
    const allowed = /^(utm_(source|medium|campaign|term|content|id)|gclid|fbclid|msclkid)$/;
    for (const [key, value] of new URLSearchParams(location.search)) {
      if (allowed.test(key) && !formUrl.searchParams.has(key)) formUrl.searchParams.set(key, value);
    }
    dialog.querySelector('h2').textContent = title;
    fallback.href = url.href;
    if (currentUrl !== formUrl.href) {
      const iframe = document.createElement('iframe');
      iframe.title = title + ' — The Avenue';
      iframe.src = formUrl.href;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      // Info-pack confirmation stays inside the form.
      const sandbox = 'allow-scripts allow-forms allow-same-origin allow-popups allow-popups-to-escape-sandbox';
      iframe.setAttribute('sandbox', sandbox + (continueToBookingPage ? ' allow-top-navigation' : ''));
      clearTimeout(loadTimer);
      footer.hidden = true;
      loading.textContent = 'Loading your form…';
      loading.hidden = false;
      const showFallback = () => {
        if (content.firstElementChild !== iframe) return;
        loading.textContent = 'Having trouble loading? You can open the form in a new tab.';
        loading.hidden = false;
        footer.hidden = false;
      };
      iframe.addEventListener('load', () => {
        if (content.firstElementChild !== iframe) return;
        clearTimeout(loadTimer);
        loading.hidden = true;
        footer.hidden = true;
      });
      iframe.addEventListener('error', () => { clearTimeout(loadTimer); showFallback(); });
      loadTimer = setTimeout(showFallback, 20000);
      content.replaceChildren(iframe);
      currentUrl = formUrl.href;
    }
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    dialog.querySelector('.avenue-popup-close').focus();
  });
})();

/* Link contact details in Shopify's automatically managed policy content. */
(() => {
  const root = document.querySelector('.shopify-policy__body');
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  for (const node of nodes) {
    if (node.parentElement.closest('a,script,style')) continue;
    const pattern = /info@theavenue\.net\.au|\+61 485 013 723|0485 013 723/g;
    const matches = [...node.textContent.matchAll(pattern)];
    if (!matches.length) continue;
    const fragment = document.createDocumentFragment();
    let start = 0;
    for (const match of matches) {
      fragment.append(document.createTextNode(node.textContent.slice(start, match.index)));
      const link = document.createElement('a');
      link.href = match[0].includes('@') ? 'mailto:info@theavenue.net.au' : 'tel:+61485013723';
      link.textContent = match[0];
      fragment.append(link);
      start = match.index + match[0].length;
    }
    fragment.append(document.createTextNode(node.textContent.slice(start)));
    node.replaceWith(fragment);
  }
})();
